import { Box, Paper } from '@mui/material';

import type { HTMLAttributes } from 'react';
const GOOGLE_LOGO =
  'https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3_hdpi.png';

export const PaperWithBottom = (props: HTMLAttributes<HTMLElement>) => {
  return (
    <Paper elevation={4} {...props}>
      {props.children}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          margin: '0 10px 10px',
        }}
      >
        <img src={GOOGLE_LOGO} alt={'google'} height={'18px'} />
      </Box>
    </Paper>
  );
};
